import { render, staticRenderFns } from "./purchasebysupplierreport.vue?vue&type=template&id=bb38f8e6&"
import script from "./purchasebysupplierreport.vue?vue&type=script&lang=js&"
export * from "./purchasebysupplierreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports